/* eslint-disable @typescript-eslint/no-explicit-any */
import ElementAnimation from 'containers/NewWordsFrame/ElementAnimation';
import SvgObject from 'containers/NewWordsFrame/SvgObject';
import * as d3 from 'd3';
import {assert} from 'utils/assert';
import {debuggableClass, memo} from 'utils/decorators';

@debuggableClass
export default class CardGroup {
  constructor(
    public parent: SvgObject,
    public groupG: SVGGElement,
    public getMinStartTime: () => number,
  ) {}
  @memo get sel() {
    return d3.select(this.groupG);
  }
  @memo get bbox() {
    return this.sel.node()!.getBBox();
  }
  @memo get showIntersectionRatio() {
    return (this.bbox.y + this.bbox.height * 0.1) / this.parent.svgRootBboxHeight;
  }
  @memo get groupId() {
    return this.sel.attr('id');
  }
  @memo get groupNo() {
    const prefix = 'Frame ';
    assert(this.groupId.startsWith(prefix));
    const numPart = this.groupId.slice(prefix.length);
    assert(Number.isFinite(Number(numPart)));
    return Number(numPart);
  }
  @memo get rectGSel() {
    return this.sel.select('g');
  }
  @memo get rectSel() {
    return this.rectGSel.select('rect');
  }
  @memo get pathSel() {
    return this.sel.select('path');
  }
  @memo get textGSel() {
    return this.sel.select('g:nth-of-type(2)');
  }
  @memo get iconButtonSel() {
    return this.sel.select('g[id^="comment_icon"]');
  }
  @memo get cardAppearAnimation() {
    const res = new ElementAnimation(this.sel.node() as SVGElement, 0, 500, 'UPSCALE');
    (res as any).bboxTargetElem = this.rectSel.node();
    (res as any).viewBoxCenter = this.parent.viewBoxCenter;
    // Object.defineProperty(res, 'bboxTargetElem', {value: this.rectSel.node()});
    return res;
  }
  @memo get cardWordStr() {
    return this.sel
      .text()
      .trim()
      .toLowerCase();
  }
  setInitialState() {
    // this.iconButtonSel
    this.sel
      .style('cursor', 'pointer')
      .style('font-weight', 500)
      .on('mouseenter', () => {
        // const iconNode = this.iconButtonSel.node() as SVGElement | null;
        // console.log(iconNode);
        // if (!iconNode) return;
        this.parent.setTooltipCur({
          type: 'WORD',
          target: this.sel.node() as SVGElement,
          id: this.cardWordStr,
          word: this.cardWordStr,
        });
      })
      .on('mouseleave', () => {
        this.parent.setTooltipCur(null);
      });
    this.cardAppearAnimation.setInitialState();
    return this;
  }
  startAnimation() {
    this.cardAppearAnimation.start();
    return this;
  }
  @memo get startTime() {
    return Math.max(this.getMinStartTime(), Number(new Date()));
  }
  start() {
    setTimeout(() => {
      this.startAnimation();
    }, Math.max(0, this.startTime - Number(new Date())));
  }
}
